module.exports = __webpack_public_path__ + "static/media/SF-4-A (1).48bae263.mp3";